<!--DownloadQrCode:下载的二维码 2021/05/13 16:06:20 YuAng-->

<template>
  <div class="ts-download-code" v-if="!visible">
    <div v-if="visible" class="ts-scan-area">
      <q-r-code v-if="url.length > 0" class="its-qr-code" :qr-url='url' :qr-size='140' qrcodeId="teach-app"></q-r-code>
      <p>下载e课堂教师app，随时随地查看学生学习任务完成情况</p>
    </div>
    <p class="ts-scan-fold">
      <span>下载教师app</span>
      <span class="switch" @click="visible = !visible" :class="{fold: !visible}">
        <i>{{visible ? '&gt;': '&lt;'}}</i>
      </span>
    </p>
    <p class="ts-split-dot small"></p>
    <p class="ts-split-dot big"></p>
  </div>
</template>
<script>
import QRCode from '../../../../components/QRCode.vue'
import { downloadCenterApi } from '@/utils/api'
export default {
  components: { QRCode },
  name: 'DownloadQrCode',
  data() {
    return {
      visible: false,
      url: ''
    }
  },
  mounted() {
    this.visible = document.body.offsetWidth > 1600
    this.downloadApp()
  },
  methods: {
    downloadApp: function () {
      downloadCenterApi.getAppDownload('TEACHER_ANDROID').then(resp => {
        if (resp.body && resp.body.length > 0) {
          this.url = location.protocol + '//' + location.hostname + '/official/eclass/mobile/download/teacher' // 改为页面
        }
      })
    }
  }
}
</script>

<style scoped>
.ts-download-code {
  position: fixed;
  top: 124px;
  right: 0;
  z-index: 2;
}

.ts-download-code::after {
  clear: both;
  content: "";
  display: block;
}

.ts-scan-area {
  background: #2695ff;
  border-radius: 5px;
  border-radius: 5px;
  width: 180px;
  height: 240px;
  color: white;
  padding: 22px;
  float: left;
  font-size: 12px;
}

.ts-scan-fold {
  width: 46px;
  height: 104px;
  border-radius: 23.5px;
  border-radius: 23.5px;
  background: #2695ff;
  color: white;
  padding: 8px;
  float: left;
  margin: 68px 16px;
}

.ts-split-dot {
  border-radius: 50%;
  background: #2695ff;
  position: absolute;
}

.ts-split-dot.small {
  width: 8px;
  height: 8px;
  top: 43%;
  right: 66px;
}

.ts-split-dot.big {
  width: 13px;
  height: 13px;
  top: 35%;
  right: 0;
}

.ts-scan-fold .switch {
  width: 30px;
  height: 30px;
  display: inline-block;
  background: white;
  line-height: 30px;
  text-align: center;
  border-radius: 50%;
  position: relative;
  margin-top: 5px;
  cursor: pointer;
}

.ts-scan-fold .switch i {
  position: absolute;
  font-size: 28px;
  color: #2695ff;
  font-style: normal;
  right: 5px;
  top: 1px;
}

.ts-scan-fold .switch.fold i {
  right: 8px;
}

.ts-scan-area >>> #qrcode_canvas_teach-app {
   background: white;
   padding: 12.5px;
   border-radius: 6px;
   margin-bottom: 6px;
}
</style>